import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
// import MyButton from "../util/MyButton";

// MUI Stuff
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Tooltip, Typography } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import CircularProgress from "@material-ui/core/CircularProgress";

// Icons
import AddIcon from "@material-ui/icons/Add";
import CloseIcon from "@material-ui/icons/Close";
import EditIcon from "@material-ui/icons/Edit";

// Redux stuff
import { connect } from "react-redux";
import {
  postScream,
  postImage,
  clearErrors,
} from "../../redux/actions/dataActions";
import MyButton from "../../util/MyButton";

const styles = {
  submitButton: {
    position: "relative",
    float: "right",
    marginTop: "10",
  },
  progressSpinner: {
    position: "absolute",
  },
  closeButton: {
    position: "absolute",
    left: "86%",
    top: "2.5%",
  },
};

class PostScream extends Component {
  state = {
    open: false,
    body: "",
    what: "",
    fore: "",
    when: "",
    where: "",
    errors: {},
  };

  handleImage = (event) => {
    const image = event.target.files[0];
    const fromData = new FormData();
    fromData.append("image", image, image.name);
    this.props.postImage(fromData);
  };
  handleEdPicture = () => {
    const fileInput = document.getElementById("postImageInput");
    fileInput.click();
  };

  componentWillReceiveProps(nextProp) {
    if (nextProp.UI.errors) {
      this.setState({
        errors: nextProp.UI.errors,
      });
    }

    if (!nextProp.UI.errors && !nextProp.UI.loading && !nextProp.Image.load) {
      this.setState({
        body: "",
        what: "",
        fore: "",
        when: "",
        where: "",
        open: false,
        errors: {},
      });
    }
  }
  handleOpen = () => {
    this.setState({ open: true });
  };
  handleClose = () => {
    this.props.clearErrors();
    this.setState({ open: false, errors: {} });
  };
  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };
  handleSubmit = (event) => {
    event.preventDefault();
    this.props.postScream({
      body: this.state.body,
      what: this.state.what,
      fore: this.state.fore,
      when: this.state.when,
      where: this.state.where,
    });
  };
  render() {
    const { errors } = this.state;
    const {
      classes,
      UI: { loading },
      Image: { load },
    } = this.props;
    return (
      <Fragment>
        <MyButton onClick={this.handleOpen} tip="Post a scream!">
          <AddIcon style={{ color: "white" }} />
        </MyButton>
        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          fullWidth
          maxWidth="sm"
        >
          <MyButton
            tip="Close"
            onClick={this.handleClose}
            tipClassName={classes.closeButton}
          >
            <CloseIcon />
          </MyButton>
          <DialogTitle>
            Post a new scream
            <Typography color="textSecondary">
              Note: You cannot post a scream without image
            </Typography>
            <Typography color="textSecondary">
              If you donot choose a picture it will post a randum picture
            </Typography>
          </DialogTitle>
          <DialogContent>
            <input
              type="file"
              id="postImageInput"
              hidden="hidden"
              onChange={this.handleImage}
            />
            <form onSubmit={this.handleSubmit}>
              <Tooltip title="Upload Image for scream!" placement="top">
                <IconButton
                  onClick={this.handleEdPicture}
                  disabled={load}
                  className="button"
                >
                  <EditIcon color="primary" />
                  <Fragment>
                    Upload photo
                    {/* {load && (
                      <CircularProgress
                        size={30}
                        className={classes.progressSpinner}
                      />
                    )} */}
                    {load === true ? (
                      <Fragment>
                        <CircularProgress
                          size={30}
                          className={classes.progressSpinner}
                        />
                      </Fragment>
                    ) : null}
                  </Fragment>
                </IconButton>

                {/* <Fragment>
                  Upload photo
                  {loading && (
                    <CircularProgress
                      size={30}
                      className={classes.progressSpinner}
                    />
                  )}
                </Fragment> */}
              </Tooltip>

              <TextField
                name="body"
                type="text"
                label="Body"
                multiline
                rows="3"
                placeholder="Write something about the event"
                error={errors.body ? true : false}
                helperText={errors.body}
                className={classes.textField}
                onChange={this.handleChange}
                fullWidth
                style={{ paddingBottom: "10px" }}
              />
              <TextField
                name="what"
                type="text"
                label="What"
                placeholder="Write event name"
                error={errors.what ? true : false}
                helperText={errors.what}
                className={classes.textField}
                onChange={this.handleChange}
                fullWidth
                style={{ paddingBottom: "10px" }}
              />
              <TextField
                name="fore"
                type="text"
                label="Which Year & Stream"
                placeholder="The event is for "
                error={errors.fore ? true : false}
                helperText={errors.fore}
                className={classes.textField}
                onChange={this.handleChange}
                fullWidth
                style={{ paddingBottom: "10px" }}
              />
              <TextField
                name="when"
                type="text"
                label="When"
                placeholder="Date and Time of the event"
                error={errors.when ? true : false}
                helperText={errors.when}
                className={classes.textField}
                onChange={this.handleChange}
                fullWidth
                style={{ paddingBottom: "10px" }}
              />
              <TextField
                name="where"
                type="text"
                label="Venue/Site Name"
                placeholder="Venue/Site Name"
                error={errors.where ? true : false}
                helperText={errors.where}
                className={classes.textField}
                onChange={this.handleChange}
                fullWidth
                style={{ paddingBottom: "10px" }}
              />
              <Button
                type="submit"
                varient="contained"
                color="secondary"
                className={classes.submitButton}
                disabled={loading}
                style={{ paddingTop: "10px" }}
              >
                Post Scream
                {loading && (
                  <CircularProgress
                    size={30}
                    className={classes.progressSpinner}
                  />
                )}
              </Button>
            </form>
          </DialogContent>
        </Dialog>
      </Fragment>
    );
  }
}

PostScream.propTypes = {
  postScream: PropTypes.func.isRequired,
  UI: PropTypes.object.isRequired,
  postImage: PropTypes.func.isRequired,
  Image: PropTypes.func.isRequired,
  clearErrors: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  UI: state.UI,
  Image: state.Image,
});

export default connect(mapStateToProps, { postScream, postImage, clearErrors })(
  withStyles(styles)(PostScream)
);
